// import React, { Fragment, lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

import * as modules from "routers/modules";
export const routerArray = [];
Object.keys(modules).forEach((item) => {
  routerArray.push(...modules[item]);
});

const routeList = [
  ...routerArray,
  {
    path: "*",
    element: <Navigate to="error/404" />,
  },
];

const RenderRouter = () => {
  const element = useRoutes(routeList);
  return element;
};

export const localRouters = routeList;
export default RenderRouter;
